import { render } from 'solid-js/web';
import App from './App';
import './styles/index.css';
import '../public/flags/freakflags.css';
import { initConsoleWarning } from './utils/consoleWarning';

// Display security warning in console
initConsoleWarning();

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

render(() => <App />, root);
